<template>
  <AppButtonDropdown
    :class="buttonClasses"
    :color="color"
    :dense="dense"
    :loading="loading"
    :dropdown-icon="dropdownIcon"
    :text-color="textColor"
    class="text-11-400"
    flat
    :label="label"
    :no-icon-animation="noIconAnimation"
    v-bind="$attrs"
    auto-close
    @input="inputHandle"
  >
    <template #label>
      <slot name="label"/>
    </template>
    <AppList
      class="no-hover dropdown-list"
      dense
    >
      <template v-for="(item, index) in menu">
        <q-item
          :key="`item-${index}`"
          :to="item.route"
          class="q-ma-sm list-link cursor-pointer border-radius-10"
          :disable="item.disable"
          :active="item.active"
          @click.native="onItemClick(item)"
        >
          <q-item-section
            v-if="item.icon || item.img"
            avatar
          >
            <q-icon
              v-if="item.icon"
              :name="item.icon"
              color="dark"
              size="18px"
              class="link-icon"
            />
            <q-img
              v-else
              class="flag"
              :src="item.img"
            />
          </q-item-section>
          <q-item-section class="q-py-sm">
            <q-item-label class="text-dark text-16-400">
              {{ item.title }}
            </q-item-label>
            <q-item-label
              v-if="item.lead"
              caption
              class="text-11-400"
            >
              {{ item.lead }}
            </q-item-label>
          </q-item-section>
        </q-item>
        <q-separator
          v-if="index !== menu.length - 1"
          :key="`separator-${index}`"
          class="q-mx-sm"
          color="grey-2"
        />
      </template>
    </AppList>
  </AppButtonDropdown>
</template>

<script>
import AppList from 'common/components/AppList';
import AppButtonDropdown from 'common/components/buttons/AppButtonDropdown';

export default {
  name: 'ActionsDropdown',
  components: {
    AppList,
    AppButtonDropdown,
  },
  props: {
    menu: {
      type: Array,
      default: () => ([]),
    },
    dropdownIcon: {
      type: String,
      default: 'more_vert',
    },
    color: {
      type: String,
      default: 'dark',
    },
    textColor: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      default: undefined,
    },
    dense: {
      type: Boolean,
      default: true,
    },
    noIconAnimation: {
      type: Boolean,
      default: true,
    },
    iconMode: {
      type: Boolean,
      default: false,
    },
    isHoverAction: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dropdownMenuState: false,
    };
  },
  computed: {
    buttonClasses() {
      return {
        'hover-action': this.isHoverAction && !this.dropdownMenuState && !this.loading && this.$q.platform.is.desktop,
        'icon-button no-hover': this.iconMode,
      };
    },
  },
  methods: {
    // itemListClasses(item) {
    //   return {
    //     'list-separator': item.separator,
    //     'border-bottom-list': !item.separator,
    //   };
    // },
    inputHandle(event) {
      this.dropdownMenuState = event;
      this.$emit('input', event);
    },
    async onItemClick(item) {
      if (!item.disable) {
        if (item.action) {
          this.$emit('apply', item.action);
        }
        if (item.handler) {
          item.handler();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .q-item {
  padding: 5px 12px !important;

  &__section--side {
    padding-right: 10px !important;
  }
}

.dropdown-list {
  min-width: 180px;
}

.list-link {
  background-color: $grey-3;

  &:hover {
    background-color: $primary;
  }
}

.q-item--active {
  .link-icon {
    color: $primary !important;
  }
}

.q-item--active {
  color: $primary;
}

::v-deep .q-btn-dropdown {
  &__arrow, &--simple {
    margin-left: 0 !important;
  }
}

.flag {
  width: 20px;
}
</style>
